import {ConsumerLocale} from "../types/ConsumerLocale";

export const isRtl = (languages: ConsumerLocale[], lioLocaleId?: number | null) => {
	return languages.find((lang) => lang.lioLocaleId === lioLocaleId)?.rtl || false;
};
